import {
  Apollo_gql,
  GraphPayload,
  GraphQueryInput,
  GraphQueryPayload,
  createQuery,
  graphQlTake,
} from '@camelot/server';

import { CalendarNote } from './dto/note';
import { CalendarVisitEvent } from './dto/visit';

export function GET_CALENDAR_NOTES(input: GraphQueryInput<CalendarNote>): GraphPayload {
  return createQuery<CalendarNote>('calendarNotes', { ...input, prefixType: 'CalendarNote' });
}

export function GET_CALENDAR_UNAVAILABILITIES(input: GraphQueryInput<CalendarVisitEvent>): GraphPayload {
  return createQuery<CalendarVisitEvent>('unavailabilities', { ...input, prefixType: 'Unavailability' });
}

export function GET_EXTERNAL_EVENTS<T>(input: GraphQueryInput<T>): GraphPayload {
  return createQuery<T>('externalEvents', { ...input, prefixType: 'ExternalEvent' });
}

export function GET_VISIT_EVENTS<T>(input: GraphQueryInput<T>): GraphPayload {
  return createQuery<T>('visits', { ...input, prefixType: 'Visit' });
}

export function GET_VISIT_EVENTS_FOR_PLANNING(input: GraphQueryInput<CalendarVisitEvent>): GraphPayload {
  return createQuery<CalendarVisitEvent>('visits', { ...input, prefixType: 'Visit' });
}

export function GET_NOTE_TYPES(where: string, props: string, order: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query NoteTypes {
          noteTypes(${order}, ${where}, ${graphQlTake()}) {
            items {
              ${props}
            }
          }
        }
      `,
    variables: {},
  };
}

export function GET_COLOR_SETS(where: string, props: string, order: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query ColorSets {
          colorSets(${order}, ${where}, ${graphQlTake()}) {
            items {
              ${props}
            }
          }
        }
      `,
    variables: {},
  };
}
export function GET_CALENDAR_SYNC_CONFIG(props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query CalendSyncConfiguration {
          calendSyncConfiguration {
            ${props}
          }
        }
      `,
    variables: {},
  };
}

export function GET_USER_CALENDAR_SUBSCRIPTION_BY_USER(userId: string, props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query UserCalendarSubscription($userId: UUID!) {
          userCalendarSubscription(userId: $userId) {
            ${props}
          }
        }
      `,
    variables: {
      userId: userId,
    },
  };
}
export function GET_CALENDAR_TIME_ENTRIES(where: string, props: string): GraphQueryPayload {
  return {
    query: Apollo_gql`
        query TimeEntries {
          timeEntries(${where}, ${graphQlTake()}) {
            items {
              ${props}
            }
          }
        }
      `,
    variables: {},
  };
}
